import React from "react";
import {
  Container,
  Desc,
  Contact,
  IconGroup,
  IconItem,
  Image,
  Info,
  Left,
  Name,
  Right,
} from "./Hero.Elements";
import "./hero.css";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <Container>
      <Left>
        <Image src='https://res.cloudinary.com/sumailcodes/image/upload/v1652032602/blog/portfolio-banner_edwfa8.webp' />
      </Left>
      <Right>
        <Info>
          <Name className='name'>Sumail Shaik</Name>
          <Desc className='desc'>
            I am a Web Developer and Programmer living in India. I will Design &
            Build Web applications using MERN Technology. I am also curios to
            know about technologies and love to write articles in my Blog
            application.
          </Desc>
          <Contact className='contact'>
            <Link
              // reloadDocument
              style={{ textDecoration: "none", color: "inherit" }}
              to='/about'
            >
              About
            </Link>
          </Contact>
        </Info>
      </Right>
    </Container>
  );
};

export default Hero;
